import { SMINEX_CLUB_PERMISSION } from '../model/consts';

export const isSuperAdmin = (groupId: number | null | undefined): boolean => groupId === null;

export const hasSminexClubPermission = (permissions: string[]): boolean => permissions.includes(SMINEX_CLUB_PERMISSION);

export const hasSminexClubAccess = (groupId: number | null | undefined, permissions: string[]): boolean =>
  isSuperAdmin(groupId) || hasSminexClubPermission(permissions);
